import { useRef } from 'react';
import { shallowEqual } from 'react-redux';

/** Returns the previous object while its fields are shallow-equal, so `...rest` props can be memo deps. */
export const useShallowStable = value => {
    const ref = useRef(value);

    if (!shallowEqual(ref.current, value)) {
        ref.current = value;
    }

    return ref.current;
};
